import type { InboxItemDetail } from '@fos/shared/contracts/inbox';
import type { ComponentType, ReactNode } from 'react';

/**
 * Sloty Inboxu dla kompozycji (bez importów innych modułów w kodzie Inboxu):
 *  - widok wiadomości (Fala 4): pozycja z wątkiem poczty (`event.threadId`) w podglądzie pokazuje wątek z odpowiedzią,
 *    Copilotem i przypisaniem do klienta zamiast samej treści zdarzenia. Kompozycja rejestruje go w
 *    `features/composition` (`ThreadView` z modułu poczty). Bez rejestracji podgląd pokazuje treść zdarzenia.
 */
export interface InboxMessageViewProps {
  item: InboxItemDetail;
  /** menu „…” pozycji (przeczytane / nieprzeczytane, zmiana ważności) — obok tytułu wątku */
  menu: ReactNode;
  /** akcje pozycji (Zrobione / Przywróć, Odłóż) — obok „Odpowiedz” */
  actions: ReactNode;
  /** banery pozycji (odłożona do …) */
  banners: ReactNode;
}

let messageView: ComponentType<InboxMessageViewProps> | null = null;

export function setInboxMessageView(view: ComponentType<InboxMessageViewProps> | null): void {
  messageView = view;
}

export function getInboxMessageView(): ComponentType<InboxMessageViewProps> | null {
  return messageView;
}
